import SmoothScroll from "@/components/site/SmoothScroll";
import Seo from "@/components/site/Seo";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import Specialty from "@/components/site/Specialty";
import Categories from "@/components/site/Categories";
import Ribbon from "@/components/site/Ribbon";
import Process from "@/components/site/Process";
import Partner from "@/components/site/Partner";
import Projects from "@/components/site/Projects";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import AreasServed from "@/components/site/AreasServed";
import Enquiry from "@/components/site/Enquiry";
import Footer from "@/components/site/Footer";
import { useReviews } from "@/hooks/usePublicContent";

export default function Landing() {
  const { items: reviews } = useReviews();
  return (
    <SmoothScroll>
      <Seo pageKey="home" reviews={reviews} />
      <div className="grain-overlay" aria-hidden />
      <main data-testid="landing-page" className="bg-[#f8fafc] min-h-screen">
        <Navbar />
        <Hero />
        <TrustBar />
        <Specialty />
        <Categories />
        <Ribbon />
        <Process />
        <Projects />
        <Partner />
        <Gallery />
        <Testimonials />
        <AreasServed />
        <Enquiry />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
